import Vue from 'vue'

Vue.mixin({
  methods: {
    assignAgentClassToBody: function () {
      const agent = navigator.userAgent
      if (agent.indexOf('iPhone') >= 0) {
        document.body.classList.add('agent-iphone')
      } else if (agent.indexOf('iPad') >= 0) {
        document.body.classList.add('agent-ipad')
      } else if (agent.indexOf('Android') >= 0) {
        document.body.classList.add('agent-android')
      }
    },
    getElementYPosition: function (element) {
      const yPosition = window.pageYOffset + element.getBoundingClientRect().top
      return yPosition
    },
    onFrontAnimeEnter (event) {
      if (event.scrollDirection === 'FORWARD') {
        event.currentTarget.triggerElement().nextElementSibling.classList.add('active')
      }
    },
    toArray: function (obj) {
      var array = []
      for (var i = obj.length >>> 0; i--;) {
        array[i] = obj[i]
      }
      return array
    }
  }
})



// WEBPACK FOOTER //
// ./src/bin/utility.js